class Insurer {
  id: string;

  name: string;

  cnpj: string;

  address: string;

  active: boolean;

  createdAt: Date;

  updatedAt: Date;
}

export default Insurer;
